export const filterOptions = [
  {
    title: 'Deal Types',
    component: 'RefinementList',
    attribute: 'publicData.listingType',
    searchablePlaceholder: 'category',
  },
  {
    title: 'Discipline',
    component: 'RefinementList',
    attribute: 'specifyDiscipline', //if user role is company disciplines.label
    searchablePlaceholder: 'discipline',
  },
  { title: 'Price', attribute: 'price.amount', label: 'Price', key: 'price' },
];

export const filterVariable = {
  Price: 'price.amount',
  ['Deal Types']: 'publicData.listingType',
};
